<script>
import Loader from "@/components/custom/Loader.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "DeleteModal",
  props: {
    value: Boolean,
    id: Number,
    shiftId: Number,
    action: String,
    country_id: Number,
    type: String,
  },
  data() {
    return {
      load: false,
    };
  },
  computed: {
    ...mapGetters(["isLoadingGet"]),
    isLoading() {
      return this.isLoadingGet;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    isLoading(isLoading) {
      if (isLoading) {
        this.load = true;
      } else {
        this.load = false;
      }
    },
  },
  methods: {
    ...mapMutations(["SET_LOADING"]),
    agree() {
      this.SET_LOADING(true);
      // debugger;
      this.$store.dispatch(`${this.$props.action}`, {
        payload: this.$props.id,
        shiftId: this.$props.shiftId, // backend
        SHIFTID: this.$props.shiftId, // refresh action
        EMPRPTYPE: this.type,
        country_id: this.country_id,
      });
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
  },
  components: {
    Loader,
  },
};
</script>
<template>
  <v-dialog v-model="show" max-width="500px">
    <Loader v-if="load" />
    <v-card v-else class="prime">
      <v-toolbar dark color="prime" dense flat></v-toolbar>
      <v-card-text class="white--text">
        <div class="text-center">
          <h4 class="white--text">
            {{ $t("deleteConfirm") }}
          </h4>
        </div>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          text
          class="font-weight-bold"
          @click.native="cancel"
          >{{ $t("cancel") }}</v-btn
        >
        <v-btn
          color="red"
          class="font-weight-bold"
          outlined
          @click.native="agree"
          >{{ $t("confirm") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
